import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import { useTranslation } from 'react-i18next'

interface IProps {
  onConfirmAction: () => void
  onCancelAction: () => void
  message: string
  isOpen: boolean
}

const ConfirmModal = ({ isOpen, onCancelAction, onConfirmAction, message }: IProps) => {
  const { t } = useTranslation()
  return (
    <Dialog className="mg-alert" open={isOpen} onClose={onCancelAction} id="modal">
      <DialogContent>
        <div className="mg-alert__content">
          <div className="mg-alert__content__icon">
            <span className="material-icons notranslate">info</span>
          </div>
          <span className="mg-alert__content__text">{message}</span>
        </div>
      </DialogContent>
      <DialogActions>
        <div className="mg-alert__buttons">
          <button
            type="button"
            className="vtmn-btn vtmn-btn_size--small vtmn-btn_variant--secondary mg-button-delete"
            onClick={onCancelAction}
          >
            {t('no')}
          </button>
          <button type="button" className="vtmn-btn vtmn-btn_size--small" onClick={onConfirmAction}>
            {t('yes')}
          </button>
        </div>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmModal
